import styled from 'styled-components';

const Wrapper = styled.section`
  h2 {
    font-size: 1.1rem;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.01em;
    margin-bottom: 1.25rem;
    text-transform: none;
  }

  & > h5 {
    font-size: 0.875rem;
    font-weight: 600;
    color: #64748b;
    margin-bottom: 1.5rem;
  }

  .jobs {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  @media (min-width: 992px) {
    .jobs {
      grid-template-columns: 1fr 1fr;
      gap: 1.25rem;
    }
  }
`;

export default Wrapper;
